import { render, staticRenderFns } from "./ProjectSampleTable.vue?vue&type=template&id=95873920"
import script from "./ProjectSampleTable.vue?vue&type=script&lang=js"
export * from "./ProjectSampleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports